import { useEffect, useRef, useState } from "react";
import IC_RECOLLECT_VOICE from "@/assets/common/ic_recollect_voice.svg?react";
import IC_COLLECTOR_PAUSE from "@/assets/common/ic_collector_pause.svg?react";
import IC_COLLECTOR_PLAY from "@/assets/common/ic_collector_play.svg?react";
import IC_COLLECTOR_SUBMITTING from "@/assets/common/ic_collector_submitting.png";
import IC_COLLECTOR_LOTTIE_PAUSE from "@/assets/common/ic_collector_lottie_pause.svg?react";
import IC_COLLECTOR_MIN from "@/assets/common/ic_collector_min.svg?react";
import IC_COLLECTOR_SEC from "@/assets/common/ic_collector_sec.svg?react";

import WAVAudio, { WAVAudioRef } from "@/component/AudioVisualizer/WAVAudio";
import "./index.css";

export interface IVoiceCollectResultProps {
  audioUrl: string;
  isSubmitting: boolean;
  handleReCollect: () => void;
  handleSubmit: () => void;
}

const VoiceCollectResult: React.FC<IVoiceCollectResultProps> = ({
  audioUrl,
  isSubmitting,
  handleReCollect,
  handleSubmit,
}) => {
  const [audioPlaying, setAudioPlaying] = useState(false);
  const wavAudioRef = useRef<WAVAudioRef>(null);
  const [isAudioVisualizerLoaded, setAudioVisualizerLoaded] = useState(false);

  useEffect(() => {
    const wavAudio = wavAudioRef.current;
    return () => {
      wavAudio?.stop();
    };
  }, []);

  // 播放/暂停
  const toggle = () => {
    if (!isAudioVisualizerLoaded) {
      setAudioVisualizerLoaded(true);
    }
    wavAudioRef.current?.toggle();
  };

  const onIsPlayingChange = (isPlaying: boolean) => {
    setAudioPlaying(isPlaying);
  };


  return (
    <div className="w-full h-full flex flex-col items-center justify-center">
      <div className="font-600 text-size-6 text-mx-secondary">完成采集</div>
      <div className="mt-9.5 w-90 h-12 pl-2 pr-4 py-2 rounded-25 flex justify-between items-center  b-#ECEEF3 b-1 b-solid">
        {audioPlaying ? (
          <IC_COLLECTOR_PLAY
            className="w-8 h-8 cursor-pointer"
            onClick={toggle}
          />
        ) : (
          <IC_COLLECTOR_PAUSE
            className="w-8 h-8 cursor-pointer"
            onClick={toggle}
          />
        )}
        <div className="relative w-56 h-4.5">
          <div
            className={`absolute w-full h-full ${
              isAudioVisualizerLoaded ? "" : "z--1"
            }`}
          >
            <WAVAudio
              ref={wavAudioRef}
              onIsPlayingChange={onIsPlayingChange}
              audioUrl={audioUrl}
            />
          </div>
          <div className={`absolute ${isAudioVisualizerLoaded ? "z--1" : ""}`}>
            <IC_COLLECTOR_LOTTIE_PAUSE />
          </div>
        </div>
        <div className="text-mx-tertiary text-size-3.5 font-500">
          00
          <IC_COLLECTOR_MIN className="h-4.25 mx-0.2" />
          15
          <IC_COLLECTOR_SEC className="h-4.25 mx-0.2" />
          </div>
      </div>
      <div
        className="mt-6 w-90 cursor-pointer h-12 rounded-2.5 flex items-center justify-center rounded-2.5 bg-#4981F2 text-#fff"
        onClick={handleSubmit}
      >
        {isSubmitting ? (
          <img
            src={IC_COLLECTOR_SUBMITTING}
            className="w-6 h-6 rotating-image"
          />
        ) : (
          "确认提交"
        )}
      </div>
      <div
        className="flex cursor-pointer items-center justify-center mt-9 text-size-3.5 text-#4981F2"
        onClick={handleReCollect}
      >
        重新采集
        <IC_RECOLLECT_VOICE className="ml-2 w-4 h-4" />
      </div>
    </div>
  );
};

export default VoiceCollectResult;
